var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgressBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3723 0H13.0016C12.6551 0 12.3738 0.280859 12.3738 0.627734V1.8957C12.3738 2.24219 12.6551 2.52344 13.0016 2.52344H15.6926L10.1863 8.0293L7.85195 5.69492C7.35898 5.20234 6.56016 5.20234 6.06719 5.69492L0.183984 11.5789C-0.0613281 11.8238 -0.0613281 12.2215 0.183984 12.4664L1.08047 13.3633C1.32539 13.6082 1.72305 13.6082 1.96797 13.3633L6.95977 8.37148L9.29375 10.7059C9.78668 11.1989 10.5856 11.1991 11.0785 10.7059L17.4766 4.30781V6.99883C17.4766 7.34531 17.7574 7.62656 18.1043 7.62656H19.3723C19.7191 7.62656 20 7.34531 20 6.99883V0.627734C20 0.280859 19.7191 0 19.3723 0Z",
    fill: "#CCAA65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressBlue);
export default __webpack_public_path__ + "static/media/InProgressBlue.8724e1d5e8a3120ce2e48a6cd8fc197c.svg";
export { ForwardRef as ReactComponent };